<script setup lang="ts">
import {Field_Entries, FieldInterface} from "../../../../gql/types/types";
import {FormKit} from "@formkit/vue"
import {computed} from "vue";
import CustomCheckbox from "./includes/CustomCheckbox.vue";
import { VServices } from "@libVue/base";
import { TranslationService } from "../../../../services/translation.service";

const SERVICES = VServices({translation:TranslationService})

const t = (key: string) => {
  return SERVICES.translation.t(key)
}

const {field} = defineProps({
  field: {
    type: Object as () => Field_Entries,
    required: true
  },
  formValues:{
    type:Object,
    required:true
  }
})
const options = computed(() => {
  return field.entries?.map((entry) => {
    if (entry)
      return {
        label: t(entry.title as string),
        value: entry.id
      }
    else return null
  })
})


const translatedLabel = computed(() => {
  return t(field.label as string)
})


const translatedOptionLabel = computed(() => {
  return options.value?.map((option) => {
    if (option) {
      return {
        label: t(option.label as string),
        value: option.value
      }
    } else return null
  })
})


</script>

<template>
  <FormKit v-if="field.displayType=='checkboxes'" type="checkbox" :id="`field:${field.handle}`" :validation="field.required ? 'required|min:1': '' " :name="field.handle!" :options="options" :label="translatedLabel"  :outer-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput' ? 'grid grid-cols-2 gap-6 justify-between !mb-0 m:block': '' " :fieldset-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput'? 'contents': ''" label-class="ml-6">
    <template #decorator>
      <custom-checkbox />
    </template>
  </FormKit>
  <FormKit v-if="field.displayType=== 'dropdown'" type="select" :id="`field:${field.handle}`" :validation="field.required ? 'required|min:1' : '' " :name="field.handle" :options="translatedOptionLabel" :label="translatedLabel"></FormKit>
  <FormKit v-if="field.displayType === 'radio'" type="radio" :id="`field:${field.handle}`" :validation="field.required ? 'required|min:1' : '' " :name="field.handle" :options="options" :label="translatedLabel" :outer-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput' ? 'grid grid-cols-2 gap-6 justify-between !mb-0 m:block': '' " :fieldset-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput'? 'contents': ''" label-class="ml-6">
    <template #decorator>
      <div class="peer-focus:ring peer-checked:bg-primary-600 peer-checked:border-primary-600 border rounded-full border-black w-5 h-5 flex items-center justify-center">
        <div class="peer-checked:block hidden w-2 h-2 rounded-full bg-white"></div>
      </div>
    </template>
  </FormKit>
</template>

<style scoped lang="scss">

</style>

